


























































import Vue from 'vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

interface PostgradMinPeriodInformation {
  id: number;
  title: string;
  minPeriod: number;
}

export default Vue.extend({
  components: {
    pxModal,
    pxButton,
  },
  props: {
    minPeriodError: {
      type: Boolean,
      default: false,
    },
    inEditingPage: {
      type: Boolean,
      default: false,
    },
    savingMinPeriodInformation: {
      type: Boolean,
      default: false,
    },
    minPeriodOptions: {
      type: Array as Vue.PropType<PostgradMinPeriodInformation[]>,
      required: true,
    },
  },
  data() {
    return {
      closingModal: false,
      minPeriodOption: null,
    };
  },
  computed: {
    optionNotChosen() {
      return !this.minPeriodOption?.title;
    },
  },
  methods: {
    closeModal() {
      if (this.closingModal || this.savingMinPeriodInformation) return;
      this.closingModal = true;
      this.$emit('close');
    },
    saveInformation() {
      if (
        this.closingModal ||
        this.savingMinPeriodInformation ||
        (this.optionNotChosen && !this.inEditingPage)
      )
        return;
      this.$emit('saveInfo', this.minPeriodOption);
    },
    selectInformation(option) {
      this.minPeriodOption = option;
    },
    isSelectedOption(option) {
      return JSON.stringify(this.minPeriodOption) === JSON.stringify(option);
    },
  },
});
